import React, { useEffect, useState } from "react";
import "./ChangeEmailModal.css";
import { FaEnvelope, FaLock } from "react-icons/fa";

const ChangeEmailModal = ({ isOpen, onClose, onConfirm, currentEmail }) => {
  const [emailAtual, setEmailAtual] = useState(currentEmail || "");
  const [novoEmail, setNovoEmail] = useState("");
  const [senha, setSenha] = useState("");

  useEffect(() => {
    if (isOpen) {
      setEmailAtual(currentEmail || "");
      setNovoEmail("");
      setSenha("");
    }
  }, [isOpen, currentEmail]);

  if (!isOpen) {
    return null;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirm({ email_atual: emailAtual, novo_email: novoEmail, senha });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Alterar Email</h2>
        <p className="modal-helper-text">
          Confirme seu email atual, informe o novo endereço e digite a senha para receber um novo link de verificação.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="modal-input-group">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              placeholder="Email Atual"
              value={emailAtual}
              readOnly
              className="input-readonly"
              required
            />
          </div>
          <div className="modal-input-group">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              placeholder="Novo Email"
              value={novoEmail}
              onChange={(e) => setNovoEmail(e.target.value)}
              required
            />
          </div>
          <div className="modal-input-group">
            <FaLock className="input-icon" />
            <input
              type="password"
              placeholder="Senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </div>
          <div className="modal-actions">
            <button type="button" onClick={onClose} className="button-secondary">
              Cancelar
            </button>
            <button type="submit" className="btn-modern">
              Atualizar Email
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeEmailModal;
